import React, { Component } from 'react';
import { 
  Collapse, 
  Container,
  Navbar, 
  NavbarBrand, 
  NavbarToggler, 
  NavItem, 
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { RoleDropdown} from './RoleDropdown';
import './NavMenu.css';
import logo from '../img/logo x home.png'

const navStyle = {
  color: 'white'
};

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.toggleAgenti = this.toggleAgenti.bind(this);
    this.toggleUtenti = this.toggleUtenti.bind(this);

    this.state = {
      collapsed: true,
      dropdownOpen: false,
      agentiOpen: false,
      agentiText: 'Seleziona Agenti',
      agenti: [],
      utentiOpen: false,
    };
  }

  componentDidMount () {
    if(sessionStorage.getItem("auth") !== null && sessionStorage.getItem("role") !== null && sessionStorage.getItem("role").includes("Superuser")){
      const headers = new Headers({
        'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
        "Content-Type": "application/json",
      })
  
      fetch(`../api/agenti`,  {
          method: 'GET',
          headers: headers
      }).then(response => response.json())
      .then(response => {
          this.setState({
            agenti: response
          })
      })
      .catch(error => {
          console.log(error);
          
      });
    }
  }
  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  toggleAgenti () {
    this.setState({
      agentiOpen: !this.state.agentiOpen
    })
  }

  toggleUtenti () {
    this.setState({
      utentiOpen: !this.state.utentiOpen
    })
  }

  toggleDropDown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("auth");
    localStorage.removeItem("role");
    sessionStorage.removeItem("auth");
    sessionStorage.removeItem("authExp");
    sessionStorage.removeItem("selectedRole")
    sessionStorage.removeItem("role");
    this.props.setRole("Role");

    console.log(sessionStorage.getItem("selectedRole"))
    this.props.history.push("/");
  }
  
  getRoles = (storage) => {
    if(storage.includes("Superuser")){
      const result = [];

      result.push("Agente");
      result.push("Amministrazione");
      result.push("Controller");

      return result;
    }
    else{
      return storage;
    }
  }

  handleAgentiIdChange = (agente) => {
    this.setState({
        agentiText: agente.nominativo,
    }, () => {
      sessionStorage.setItem("agentiId", agente.codice);
    })
  }

  render () {
    const benvenuto = (
      <Container className="d-flex align-items-center justify-content-center">
        <h6 style={{color: "#011e41", fontWeight: "bold", paddingTop: "10px"}}>AREA RISERVATA &emsp; &emsp; benvenuto: {sessionStorage.getItem("nome")}</h6>
      </Container>
    );

    const loginLinks = (
      <NavItem>
            <NavLink style={navStyle} tag={Link} to="/login">Login</NavLink>
      </NavItem>
    );

    const logoutLinks = (
      <NavItem>
        <NavLink style={navStyle} tag={Link} to="/" onClick={this.logout}>Logout</NavLink>
      </NavItem>
    );
    
    
    
    return (
      <header>
        <Container fluid>
          {localStorage.getItem("auth") !== null || (sessionStorage.getItem("auth") !== null && new Date(sessionStorage.getItem("authExp")) >= new Date()) ? benvenuto : null }
          <Navbar style={{backgroundColor: '#011e41', borderRadius: '5px'}} className="navbar-expand-md navbar-toggleable-md ng-white border-bottom box-shadow mb-3" dark>
            <Collapse className="w-100 order-1 order-md-0 dual-collapse2" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                <NavItem>
                  <NavLink style={navStyle} tag={Link} to="/">Home</NavLink>
                </NavItem>
              </ul>
            </Collapse>
            <Container className="mx-auto order-0">
                        <NavbarBrand className="mx-auto" tag={Link} to="/"><img style={{ height: 45, width: 115 }} src={logo} alt="Renieri"></img><span className="navbar-text align-middle">v.1.8.3</span></NavbarBrand>
                <NavbarToggler style={navStyle} onClick={this.toggleNavbar} className="mr-2 navbar-dark" data-target=".dual-collapse2" />
            </Container>
            <Collapse className="w-100 order-1 order-md-0 dual-collapse2" isOpen={!this.state.collapsed} navbar>
                <ul className="navbar-nav ml-auto">
                  {sessionStorage.getItem("role") !== null && JSON.parse(sessionStorage.getItem("role")).includes("Superuser") ?
                    <NavItem>
                      <NavLink style={navStyle} tag={Link} to="/test">Aggiungi Utenti</NavLink>
                    </NavItem> : null
                  }
                  {sessionStorage.getItem("selectedRole") !== null && sessionStorage.getItem("role") !== null && sessionStorage.getItem("role").includes("Superuser") ? 
                    <RoleDropdown style={navStyle} role={this.props.role} header="Choose a role" setRole={this.props.setRole}></RoleDropdown> : null
                  }
                  {sessionStorage.getItem("selectedRole") !== null && sessionStorage.getItem("role") !== null && sessionStorage.getItem("role").includes("Superuser") ? 
                    <Dropdown direction="left" nav isOpen={this.state.agentiOpen} toggle={this.toggleAgenti}>
                        <DropdownToggle style={{color: 'white'}} nav caret>
                            {this.state.agentiText}
                        </DropdownToggle>
                        <DropdownMenu
                          modifiers={{
                            setMaxHeight: {
                                enabled: true,
                                order: 890,
                                fn: (data) => {
                                return {
                                    ...data,
                                    styles: {
                                    ...data.styles,
                                    overflow: 'auto',
                                    maxHeight: "50vh",
                                    },
                                };
                                },
                            },
                            computeStyle: {
                                gpuAcceleration: false
                            }}}>
                            <DropdownItem header>Agenti</DropdownItem>
                            <Container>
                                {this.state.agenti.map(agente => {
                                  return (<DropdownItem key={agente.codice} id={agente.codice} onClick={() => this.handleAgentiIdChange(agente)}>{agente.nominativo}</DropdownItem>)
                                })}
                            </Container>
                        </DropdownMenu>
                    </Dropdown>: null
                  }
                  {localStorage.getItem("auth") !== null || (sessionStorage.getItem("auth") !== null && new Date(sessionStorage.getItem("authExp")) >= new Date()) ? logoutLinks : loginLinks}                            
                </ul>
            </Collapse>             
          </Navbar>
        </Container>
        </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js